"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateRomaneioReport = generateRomaneioReport;
var _moment = _interopRequireDefault(require("moment"));
var _pdfmake = _interopRequireDefault(require("pdfmake/build/pdfmake"));
require("pdfmake/build/vfs_fonts");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var Formatting = {
  formatDateDayMonthYear: function formatDateDayMonthYear(isoString) {
    return isoString ? (0, _moment.default)(isoString).format('DD/MM/YY') : '';
  },
  formatDateTimeNowBrazil: function formatDateTimeNowBrazil() {
    return (0, _moment.default)().format('DD/MM/YYYY HH:mm');
  },
  formatCurrencyBrazil: function formatCurrencyBrazil(value) {
    return (Number(value) || 0).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  }
};
var formatNumber = function formatNumber(number) {
  var formatted = Number(number);
  if (Number.isNaN(formatted)) return 0;
  return Math.round(formatted * 10000) / 10000;
};
var documentOptions = {
  gaps: {
    labelToValue: 4,
    field: 16,
    section: 12
  },
  fonts: {
    title: 18,
    subtitle: 16,
    label: 12,
    value: 12,
    tableHeader: 12
  },
  colors: {
    title: '#3E5F44',
    subtitle: '#5E936C',
    label: '#5E936C',
    value: '#333',
    tableHeaderBackground: '#3B8686',
    tableHeaderForeground: '#FFFFFF',
    zebra: '#E8FFD7'
  },
  page: {
    size: 'A4',
    margins: [28, 42, 28, 42]
  },
  titleText: 'Relatório sobre Romaneio',
  subtitleText: '',
  defaultPaymentForm: '--',
  defaultDueDate: ''
};
function buildViews() {
  var _item$pallets, _item$clientData, _item$clientData2, _item$plotData, _item$subPlotData;
  var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var farmContext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var getProductMetrics = function getProductMetrics(product) {
    var boxWeight = Number(product === null || product === void 0 ? void 0 : product.kg) || 0;
    var boxPrice = Number(product === null || product === void 0 ? void 0 : product.price) || 0;
    var quantity = Number(product === null || product === void 0 ? void 0 : product.qtd) || 0;
    var totalWeight = boxWeight * quantity;
    var totalPrice = boxPrice * quantity;
    var convertedWeight = Number(product === null || product === void 0 ? void 0 : product.convertion) || 0;
    var convertedQuantity = convertedWeight ? quantity * boxWeight / convertedWeight : 0;
    var convertedPrice = boxWeight ? convertedWeight * boxPrice / boxWeight : 0;
    var convertedTotalWeight = convertedWeight * convertedQuantity;
    var convertedTotalPrice = convertedPrice * convertedQuantity;
    return {
      boxWeight: boxWeight,
      boxPrice: boxPrice,
      quantity: quantity,
      totalWeight: totalWeight,
      totalPrice: totalPrice,
      convertedWeight: convertedWeight,
      convertedQuantity: convertedQuantity,
      convertedPrice: convertedPrice,
      convertedTotalWeight: convertedTotalWeight,
      convertedTotalPrice: convertedTotalPrice
    };
  };
  var getProductDisplayName = function getProductDisplayName() {
    var productData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return [productData.name, productData.variety && "- ".concat(productData.variety), productData.plant && "- ".concat(productData.plant)].filter(Boolean).join(' ').replace(/\s{2,}/g, ' ').trim();
  };
  var productItems = (item.products || []).map(function (product) {
    var metrics = getProductMetrics(product);
    var shouldConvert = Boolean(item === null || item === void 0 ? void 0 : item.useConvertedValues) && metrics.convertedWeight > 0;
    var quantity = shouldConvert ? metrics.convertedQuantity : metrics.quantity;
    var weightPerBoxInKilograms = shouldConvert ? metrics.convertedWeight : metrics.boxWeight;
    var unitPrice = shouldConvert ? metrics.convertedPrice : metrics.boxPrice;
    var totalWeightInKilograms = shouldConvert ? metrics.convertedTotalWeight : metrics.totalWeight;
    var totalPrice = shouldConvert ? metrics.convertedTotalPrice : metrics.totalPrice;
    return {
      name: getProductDisplayName((product === null || product === void 0 ? void 0 : product.productData) || {}),
      quantity: quantity,
      weightPerBoxInKilograms: weightPerBoxInKilograms,
      unitPrice: unitPrice,
      totalWeightInKilograms: totalWeightInKilograms,
      totalPrice: totalPrice
    };
  });
  var totals = productItems.reduce(function (accumulator, record) {
    return {
      grossTotal: accumulator.grossTotal + record.totalPrice,
      totalWeightInKilograms: accumulator.totalWeightInKilograms + record.totalWeightInKilograms,
      totalBoxes: accumulator.totalBoxes + record.quantity
    };
  }, {
    grossTotal: 0,
    totalWeightInKilograms: 0,
    totalBoxes: 0
  });
  return {
    header: {
      cnpjOrCpf: (farmContext === null || farmContext === void 0 ? void 0 : farmContext.cnpj) || '--',
      packingListNumber: (item === null || item === void 0 ? void 0 : item.register) || '--',
      harvestDate: (item === null || item === void 0 ? void 0 : item.harvestDate) || '',
      vehiclePlate: (item === null || item === void 0 ? void 0 : item.plate) || '--',
      totalPallets: (_item$pallets = item === null || item === void 0 ? void 0 : item.pallets) !== null && _item$pallets !== void 0 ? _item$pallets : '0'
    },
    client: {
      name: (item === null || item === void 0 ? void 0 : (_item$clientData = item.clientData) === null || _item$clientData === void 0 ? void 0 : _item$clientData.name) || '--',
      document: (item === null || item === void 0 ? void 0 : (_item$clientData2 = item.clientData) === null || _item$clientData2 === void 0 ? void 0 : _item$clientData2.cpfcnpj) || '--'
    },
    area: {
      name: (item === null || item === void 0 ? void 0 : (_item$plotData = item.plotData) === null || _item$plotData === void 0 ? void 0 : _item$plotData.name) || '--',
      subArea: (item === null || item === void 0 ? void 0 : (_item$subPlotData = item.subPlotData) === null || _item$subPlotData === void 0 ? void 0 : _item$subPlotData.nickname) || '--'
    },
    products: {
      items: productItems,
      totals: totals
    }
  };
}
function buildTopFieldsSection(viewModel) {
  var formatting = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Formatting;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : documentOptions;
  return {
    layout: 'noBorders',
    table: {
      widths: ['*', '*', '*'],
      body: [[{
        text: 'CNPJ/CPF',
        style: 'label'
      }, {
        text: 'Nº ROMANEIO',
        style: 'label'
      }, {
        text: 'DATA DE COLHEITA',
        style: 'label'
      }], [{
        text: viewModel.header.cnpjOrCpf,
        style: 'value'
      }, {
        text: viewModel.header.packingListNumber,
        style: 'value'
      }, {
        text: formatting.formatDateDayMonthYear(viewModel.header.harvestDate),
        style: 'value'
      }], [{
        text: 'PLACA DO VEÍCULO',
        style: 'label'
      }, {
        text: 'TOTAL DE PALLETS',
        style: 'label'
      }, {
        text: '',
        border: [false, false, false, false]
      }], [{
        text: viewModel.header.vehiclePlate,
        style: 'value'
      }, {
        text: String(viewModel.header.totalPallets),
        style: 'value'
      }, {
        text: '',
        border: [false, false, false, false]
      }]]
    },
    margin: [0, 0, 0, options.gaps.section]
  };
}
function buildClientSection(viewModel) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : documentOptions;
  return [{
    text: 'Dados do cliente:',
    style: 'sectionTitle',
    margin: [0, 0, 0, options.gaps.labelToValue]
  }, {
    layout: 'noBorders',
    table: {
      widths: ['*', '*'],
      body: [[{
        text: 'CLIENTE',
        style: 'label'
      }, {
        text: 'CPF / CNPJ',
        style: 'label'
      }], [{
        text: viewModel.client.name,
        style: 'value'
      }, {
        text: viewModel.client.document,
        style: 'value'
      }]]
    },
    margin: [0, 0, 0, options.gaps.section]
  }];
}
function buildAreaSection(viewModel) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : documentOptions;
  return [{
    text: 'Dados da área:',
    style: 'sectionTitle',
    margin: [0, 0, 0, options.gaps.labelToValue]
  }, {
    layout: 'noBorders',
    table: {
      widths: ['*', '*'],
      body: [[{
        text: 'ÁREA',
        style: 'label'
      }, {
        text: 'SUB-ÁREA',
        style: 'label'
      }], [{
        text: viewModel.area.name,
        style: 'value'
      }, {
        text: viewModel.area.subArea,
        style: 'value'
      }]]
    },
    margin: [0, 0, 0, options.gaps.section]
  }];
}
function buildProductsTable(viewModel) {
  var formatting = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Formatting;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : documentOptions;
  var headerRow = ['PRODUTO', 'CAIXAS', 'PESO POR CAIXA', 'PESO TOTAL', 'VALOR POR CAIXA', 'VALOR TOTAL'].map(function (text) {
    return {
      text: text,
      style: 'tableHeader'
    };
  });
  var productRows = viewModel.products.items.map(function (product) {
    return [product.name, {
      text: formatNumber(product.quantity),
      alignment: 'right'
    }, {
      text: "".concat(product.weightPerBoxInKilograms.toFixed(2), " kg"),
      alignment: 'right'
    }, {
      text: "".concat(product.totalWeightInKilograms.toFixed(2), " kg"),
      alignment: 'right'
    }, {
      text: formatting.formatCurrencyBrazil(product.unitPrice),
      alignment: 'right'
    }, {
      text: formatting.formatCurrencyBrazil(product.totalPrice),
      alignment: 'right'
    }];
  });
  productRows.push([{
    text: 'SUBTOTAL',
    colSpan: 1,
    alignment: 'right',
    bold: true
  }, {
    text: formatNumber(viewModel.products.totals.totalBoxes),
    alignment: 'right',
    bold: true
  }, {
    text: '',
    alignment: 'right'
  }, {
    text: "".concat(viewModel.products.totals.totalWeightInKilograms.toFixed(2), " kg"),
    alignment: 'right',
    bold: true
  }, {
    text: ''
  }, {
    text: formatting.formatCurrencyBrazil(viewModel.products.totals.grossTotal),
    alignment: 'right',
    bold: true
  }]);
  return {
    layout: {
      fillColor: function fillColor(index) {
        return index === 0 ? options.colors.tableHeaderBackground : index % 2 === 0 ? options.colors.zebra : null;
      },
      hLineColor: function hLineColor() {
        return '#CCCCCC';
      },
      vLineColor: function vLineColor() {
        return '#E0E0E0';
      }
    },
    table: {
      headerRows: 1,
      widths: ['*', 50, 70, 70, 80, 80],
      body: [headerRow].concat(_toConsumableArray(productRows))
    },
    margin: [0, 0, 0, options.gaps.section]
  };
}
function buildTotalsSection(viewModel) {
  var _payment$amountToPay;
  var payment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var formatting = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Formatting;
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : documentOptions;
  var amountToPay = (_payment$amountToPay = payment.amountToPay) !== null && _payment$amountToPay !== void 0 ? _payment$amountToPay : viewModel.products.totals.grossTotal;
  var dueDate = payment.dueDate || options.defaultDueDate;
  var paymentForm = payment.paymentForm || options.defaultPaymentForm;
  return {
    layout: 'noBorders',
    table: {
      widths: ['*', '*', '*', '*'],
      body: [[{
        text: 'TOTAL BRUTO',
        style: 'label'
      }, {
        text: 'R$ A PAGAR',
        style: 'label'
      }, {
        text: 'DATA DE VENCIMENTO',
        style: 'label'
      }, {
        text: 'F/ PAGAMENTO',
        style: 'label'
      }], [{
        text: formatting.formatCurrencyBrazil(viewModel.products.totals.grossTotal),
        style: 'valueBold'
      }, {
        text: formatting.formatCurrencyBrazil(amountToPay),
        style: 'valueBold'
      }, {
        text: dueDate ? Formatting.formatDateDayMonthYear(dueDate) : '--',
        style: 'valueBold'
      }, {
        text: paymentForm,
        style: 'valueBold'
      }]]
    },
    margin: [0, 12, 0, 12]
  };
}
function buildDocumentDefinition(item, farmContext, useConvertedValues) {
  var formatting = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Formatting;
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : documentOptions;
  var viewModel = buildViews(_objectSpread(_objectSpread({}, item), {}, {
    useConvertedValues: useConvertedValues
  }), farmContext);
  return {
    pageSize: options.page.size,
    pageMargins: options.page.margins,
    content: [{
      text: options.titleText,
      style: 'title',
      margin: [0, 0, 0, options.gaps.labelToValue]
    }, {
      text: (farmContext === null || farmContext === void 0 ? void 0 : farmContext.name) || options.subtitleText,
      style: 'subtitle',
      margin: [0, 0, 0, options.gaps.section]
    }, buildTopFieldsSection(viewModel, formatting, options)].concat(_toConsumableArray(buildClientSection(viewModel, options)), _toConsumableArray(buildAreaSection(viewModel, options)), [buildProductsTable(viewModel, formatting, options), buildTotalsSection(viewModel, {}, formatting, options), {
      text: 'OBS: Dados bancários ou boleto serão enviados via e-mail.',
      style: 'obs',
      margin: [0, 0, 0, options.gaps.labelToValue]
    }, {
      text: "Documento gerado em ".concat(formatting.formatDateTimeNowBrazil()),
      style: 'footerNote'
    }]),
    styles: {
      title: {
        fontSize: options.fonts.title,
        bold: true,
        alignment: 'left',
        color: options.colors.title
      },
      subtitle: {
        fontSize: options.fonts.subtitle,
        alignment: 'left',
        color: options.colors.subtitle
      },
      sectionTitle: {
        fontSize: 12,
        bold: true,
        color: options.colors.title
      },
      label: {
        fontSize: options.fonts.label,
        bold: true,
        color: options.colors.label,
        margin: [0, 0, 0, options.gaps.labelToValue]
      },
      value: {
        fontSize: options.fonts.value,
        color: options.colors.value,
        margin: [0, 0, 0, options.gaps.field]
      },
      valueBold: {
        fontSize: options.fonts.value,
        bold: true,
        color: '#111',
        margin: [0, 0, 0, options.gaps.field]
      },
      tableHeader: {
        bold: true,
        color: options.colors.tableHeaderForeground,
        alignment: 'center',
        fontSize: options.fonts.tableHeader
      },
      obs: {
        fontSize: 10,
        color: '#444'
      },
      footerNote: {
        italics: true,
        fontSize: 10,
        color: options.colors.subtitle,
        alignment: 'right'
      }
    }
  };
}
function generateRomaneioReport(romaneioData, farmData) {
  var action = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'open';
  var filename = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'romaneio.pdf';
  var useConvertedValues = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  console.log(farmData);
  var docDef = buildDocumentDefinition(romaneioData, farmData, useConvertedValues);
  var pdfDoc = _pdfmake.default.createPdf(docDef);
  if (action === 'download') {
    pdfDoc.download(filename);
    return;
  }
  if (action === 'print') {
    pdfDoc.print();
    return;
  }
  pdfDoc.open();
}